export enum MailFolder {
  Inbox = 'Inbox',
  SentItems = 'SentItems',
  DeletedItems = 'DeletedItems',
  Error = 'Error'
}
